import { render, staticRenderFns } from "./tc-tab.vue?vue&type=template&id=06a3e925&scoped=true&"
import script from "./tc-tab.vue?vue&type=script&lang=js&"
export * from "./tc-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a3e925",
  null
  
)

export default component.exports